import React, { useEffect, useState } from "react";
import DownArrow from "assets/images/general/payment-arrow.svg";
import DefaultUser from "assets/images/general_old/user-avatar.png";
import ButtonComponent from "./ButtonComponent";
import { useRecoilState, useRecoilValue } from "recoil";
import { getBreadcrumbType } from "recoil/General";
import ProfileMenu from "./ProfileMenu";
import { useNavigate } from "react-router-dom";
import { BreadCrumbsListing } from "config/BreadCrumbsListing";
import { authState } from "recoil/Auth";
import { getImagePreviewUrl } from "config/config";
import { CallAPI } from "actions/General";
import jsonToCsvExport from "json-to-csv-export";
import { ExportUnitHeaders } from "views/units/utils";
import { ExportModuleHeaders } from "views/modules/utils";
import { ExportTagHeaders } from "views/tags/utils";
import { ExportCategoryHeaders } from "views/categories/utils";
import { ExportCourseHeaders } from "views/course/utils";
import { ExportProgramHeaders } from "views/program/utils";

function TopBar() {
  const navigate = useNavigate();
  const [displayProfileMenu, setDisplayProfileMenu] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [importDataLoader, setImportDataLoader] = useState(false);

  const typeOfBreadCrumb = useRecoilValue(getBreadcrumbType);
  const [userDetail, setUserDetail] = useRecoilState(authState);

  const switchUser = async () => {
    const result = await CallAPI("SWITCH_USER_ROLE", {}, null);
    if (result.status) {
      setUserDetail({
        ...userDetail,
        authToken: result.data.access_token,
        refreshToken: result.data.refresh_token,
        role: result.data.login_role,
        actualRole: result.data.role,
      });
    }
  };

  const moveTo = (link) => {
    navigate(link);
  };

  const getImageUrl = async () => {
    if (userDetail.details.avatar) {
      let url = await getImagePreviewUrl(userDetail.details.avatar, setLoader);
      if (url) setImageUrl(url);
    }
  };
  useEffect(() => {
    getImageUrl();
  }, [userDetail?.details?.avatar]);
  const generateImportData = async () => {
    const result = await CallAPI(
      "GENERATE_IMPORT_DATA",
      null,
      null,
      setImportDataLoader
    );
    if (result.status) {
      console.log(result.data);
      jsonToCsvExport({
        data: result.data.tags,
        headers: ExportTagHeaders,
        filename: "TagsList.csv",
      });
      jsonToCsvExport({
        data: result.data.categories,
        headers: ExportCategoryHeaders,
        filename: "CategoriesList.csv",
      });
      jsonToCsvExport({
        data: result.data.units,
        headers: ExportUnitHeaders,
        filename: "UnitsList.csv",
      });
      jsonToCsvExport({
        data: result.data.modules,
        headers: ExportModuleHeaders,
        filename: "ModulesList.csv",
      });
      jsonToCsvExport({
        data: result.data.courses,
        headers: ExportCourseHeaders,
        filename: "CoursesList.csv",
      });
      jsonToCsvExport({
        data: result.data.programs,
        headers: ExportProgramHeaders,
        filename: "ProgramsList.csv",
      });
    }
  };
  return (
    <div id="kt_header" className={"header align-items-stretch"}>
      <div
        className={
          "container-fluid d-flex align-items-stretch justify-content-between"
        }
      >
        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="d-flex align-items-stretch" id="kt_header_nav">
            <div className="toolbar duplicate" id="kt_toolbar">
              <div
                id="kt_toolbar_container"
                className={"container-fluid d-flex flex-stack"}
              >
                <div
                  id="kt_page_title"
                  data-kt-swapper="true"
                  data-kt-swapper-mode="prepend"
                  data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                  className={
                    "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
                  }
                >
                  <h1
                    className="d-flex align-items-center my-1 text-hover-blue-1 cursor-pointer"
                    onClick={() =>
                      moveTo(BreadCrumbsListing[typeOfBreadCrumb].url)
                    }
                  >
                    {BreadCrumbsListing[typeOfBreadCrumb]
                      ? BreadCrumbsListing[typeOfBreadCrumb].breadcrumbs[0]
                      : ""}
                  </h1>
                  <span className="bullet bg-gray-400 w-5px h-2px mx-2"></span>
                  <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 mt-1">
                    {BreadCrumbsListing[typeOfBreadCrumb] &&
                      BreadCrumbsListing[typeOfBreadCrumb].breadcrumbs.map(
                        (item, index) =>
                          index !== 0 && (
                            <li className={""} key={index}>
                              {item}
                            </li>
                          )
                      )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-stretch flex-shrink-0">
            {/* <div className={"d-flex align-items-center ms-1 ms-lg-3"}>
              <ThemeSwitcher />
            </div> */}

            {(userDetail.actualRole === "BUSINESS_ADMIN" ||
              userDetail.actualRole === "TEACHER") &&
              userDetail.details.allow_switch_role && (
                <ButtonComponent
                  text={"switch_user"}
                  onClick={switchUser}
                  variant={`blue-1 m-auto ${
                    process.env.REACT_APP_ENV !== "local" && "d-none"
                  }`}
                  loading={importDataLoader}
                  disabled={importDataLoader}
                />
              )}
            {userDetail.role === "SUPER_ADMIN" && (
              <ButtonComponent
                text={"generate_import_data"}
                onClick={generateImportData}
                variant={`blue-1 m-auto ${
                  process.env.REACT_APP_ENV !== "local" && "d-none"
                }`}
                loading={importDataLoader}
                disabled={importDataLoader}
              />
            )}
            <div
              className={"d-flex align-items-center ms-1 ms-lg-3"}
              id="kt_header_user_menu_toggle"
            >
              <div
                className={"cursor-pointer symbol symbol-30px symbol-md-40px"}
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="bottom"
                onClick={() => setDisplayProfileMenu(!displayProfileMenu)}
              >
                <img
                  src={
                    !loader && userDetail?.details?.avatar
                      ? imageUrl
                      : DefaultUser
                  }
                  alt="metronic"
                />
                <span className="ms-2 theme-font-inter-regular">
                  Hi{" "}
                  {userDetail.role === "SUPER_ADMIN"
                    ? "Super Admin"
                    : userDetail.details.name}
                </span>
                <img
                  className="rotate-180 profile-open"
                  src={DownArrow}
                  alt="down"
                />
              </div>

              {displayProfileMenu && (
                <ProfileMenu setDisplayProfileMenu={setDisplayProfileMenu} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;

export const Toolbar = () => {
  const typeOfBreadCrumb = useRecoilValue(getBreadcrumbType);

  return (
    <>
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className={"container-fluid d-flex flex-stack"}
        >
          <div
            id="kt_page_title"
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className={
              "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            }
          >
            <h1 className="d-flex align-items-center my-1">
              {BreadCrumbsListing[typeOfBreadCrumb]
                ? BreadCrumbsListing[typeOfBreadCrumb].component
                : ""}
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};
